/**
 * DevExtreme (esm/__internal/grids/new/grid_core/sorting_controller/utils.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export function getNextSortOrder(currentOrder, ctrlKey) {
    if (ctrlKey) {
        return
    }
    if ("asc" === currentOrder) {
        return "desc"
    }
    return "asc"
}
export function sortOrderDelegate(a, b) {
    if (void 0 !== a.sortIndex && void 0 === b.sortIndex) {
        return -1
    }
    if (void 0 !== b.sortIndex && void 0 === a.sortIndex) {
        return 1
    }
    if (void 0 !== a.sortIndex && void 0 !== b.sortIndex) {
        return a.sortIndex - b.sortIndex
    }
    if (void 0 === a.sortIndex && void 0 === b.sortIndex) {
        return a.visibleIndex - b.visibleIndex
    }
    throw new Error("Invalid state")
}
